export const Question = [{
  path: 'questions',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'QuestionsAdmin',
      component: () => import('../../../components/Admin/Questions.vue'),
      meta: {
        access: ['admin', 'teacher']
      }
    },
    {
      path: 'create',
      name: 'QuestionCreate',
      component: () => import('../../../components/Admin/CreateQuestion.vue'),
      meta: {
        access: ['admin', 'teacher']
      }
    },
    {
      path: 'edit/:id',
      name: 'QuestionEdit',
      component: () => import('../../../components/Admin/EditQuestion.vue'),
      meta: {
        access: ['admin', 'teacher']
      }
    },
    {
      path: 'result',
      name: 'QuestionsResult',
      component: () => import('../../../components/Admin/QuestionsResults.vue'),
      meta: {
        access: ['admin', 'teacher']
      }
    },
    {
      path: 'result/:testID/:userID',
      name: 'QuestionsUserResult',
      component: () => import('../../../components/Admin/QuestionsUserResults.vue'),
      meta: {
        access: ['admin', 'teacher']
      }
    },
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/question.js